<template>
    <v-container>
      <!-- 데이터 테이블 -->
      <v-data-table
        :headers="headers"
        :items="quiz_list_all"
        :loading="loadingData"
        item-value="id"
        show-expand 
        :footer-props="{'items-per-page-options': [20, 50, -1]}"
      >
        <!-- 기본 행 표시 -->
        <template v-slot:item="{ item, index }">
          <tr>
            <!-- 인덱스 표시 -->
            <td><v-col style="width: 60px;">{{ index + 1 }}</v-col></td>
  
            <!-- 이미지 및 파일 입력 -->
            <td>
              <img
                :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + item.img_path"
                alt="Image"
                style="width: 120px; height: 60px;"
              />
              <v-file-input
                height="10px"
                hide-details
                outlined
                v-model="quizImageFiles[item.id]"
                @change="(file) => handleFileChange_Quiz(file, item)"
                dense
              >
                <template #label>변경</template>
              </v-file-input>
            </td>
  
            <!-- 정답 입력 -->
            <td>
              <v-text-field
                v-model="item.correct"
                outlined
                dense
                style="width: 120px;"
                hide-details
              ></v-text-field>
            </td>
  
            <!-- 답변 입력 -->
            <td>
              <v-text-field
                v-model="item.answer"
                outlined
                dense
                hide-details
              ></v-text-field>
            </td>
  
            <!-- 체크박스 -->
            <td>
              <v-checkbox
                v-model="checkbox_state_container[item.id]"
                hide-details
                label=""
                class="my-auto"
                @change="OnCheckBoxStateChange(item)"
              ></v-checkbox>
            </td>
  
            <!-- 등록 날짜 -->
            <td><v-col>{{ item.dt_regist }}</v-col></td>
  
            <!-- 삭제 버튼 -->
            <td>
              <v-btn
                width="60px"
                color="red"
                class="white--text"
                @click="OnDeleteQuiz_Item(item)"
              >
                삭제
              </v-btn>
            </td>
  
            <!-- 수정 버튼 -->
            <td>
              <v-btn
                width="60px"
                color="blue"
                class="white--text"
                @click="OnSaveQuiz_Item(item)"
              >
                수정
              </v-btn>
            </td>
          </tr>
        </template>
  
        <!-- 확장된 행 표시 -->
        <template v-slot:expanded-item="{ item }">
          <tr>
            <td colspan="8"> <!-- 전체 열 병합 -->
              <div class="pa-4">
                <h4>추가 정보</h4>
                <p>여기에 {{ item.id }}에 대한 추가 정보를 표시할 수 있습니다.</p>
                <v-list>
                  <v-list-item-group>
                    <v-list-item
                      v-for="subItem in item.subItems"
                      :key="subItem.id"
                    >
                      <v-list-item-content>
                        <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                        <v-list-item-subtitle>{{ subItem.subtitle }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </template>
  
  <script>
  export default {
    data() {
      return {
        loadingData: false, // 로딩 상태
        headers: [
          { text: '번호', value: 'index' },
          { text: '이미지', value: 'img_path' },
          { text: '정답', value: 'correct' },
          { text: '답변', value: 'answer' },
          { text: '체크', value: 'check' },
          { text: '등록일', value: 'dt_regist' },
          { text: '삭제', value: 'delete' },
          { text: '수정', value: 'edit' },
        ],
        quiz_list_all: [
          {
            id: 1,
            img_path: 'images/sample1.jpg',
            correct: '정답1',
            answer: '답변1',
            dt_regist: '2024-12-25',
            subItems: [
              { id: 101, title: '서브 항목 1', subtitle: '부가 설명 1' },
              { id: 102, title: '서브 항목 2', subtitle: '부가 설명 2' },
            ],
          },
          {
            id: 2,
            img_path: 'images/sample2.jpg',
            correct: '정답2',
            answer: '답변2',
            dt_regist: '2024-12-26',
            subItems: [
              { id: 201, title: '서브 항목 A', subtitle: '부가 설명 A' },
              { id: 202, title: '서브 항목 B', subtitle: '부가 설명 B' },
            ],
          },
        ],
        quizImageFiles: {}, // 파일 업로드 데이터를 저장
        checkbox_state_container: {}, // 체크박스 상태 관리
      };
    },
    methods: {
      handleFileChange_Quiz(file, item) {
        console.log('파일 변경됨:', file, item);
      },
      OnCheckBoxStateChange(item) {
        console.log('체크박스 상태 변경:', item);
      },
      OnDeleteQuiz_Item(item) {
        console.log('삭제 버튼 클릭:', item);
      },
      OnSaveQuiz_Item(item) {
        console.log('수정 버튼 클릭:', item);
      },
    },
  };
  </script>
  
  <style>
  .my-auto {
    margin: auto;
  }
  </style>
  